<template>
  <SidebarSection
    title="Account Settings"
  >
    <div :class="$style.container">
      <OauthProviderManagement
        :id="administratorId"
      />
      <Button
        :class="$style.noBackgroundButton"
        hasNoBackground
        :isDisabled="buttonConfigEmail.disabled"
        :isFullWidth="true"
        :isLoading="loadingEmail"
        :text="buttonConfigEmail.text"
        :type="buttonConfigEmail.type"
        @click="handleResendEmail"
      />
      <IconButton
        ref="deleteButton"
        data-test-id="AdministratorAccountSection_delete"
        hasOutline
        :icon="buttonConfigDeleteAccount.icon"
        :isDisabled="buttonDisabled"
        :isFullWidth="true"
        :isLoading="loadingDeleteAccount"
        :text="buttonConfigDeleteAccount.text"
        :type="buttonConfigDeleteAccount.type"
        @click="handleDeleteAccount"
      />
    </div>
    <ModalEmail
      :item="item"
      :showModal="showModalEmail"
      @close="handleConfirmCloseEmail"
      @save="handleConfirmContinueEmail"
    />
    <ModalDeleteAccount
      data-test-id="AdministratorAccountSection_modal"
      :item="item"
      :showModal="showModalDeleteAccount"
      @close="handleConfirmCloseDeleteAccount"
      @save="handleConfirmContinueDeleteAccount"
    />
  </SidebarSection>
</template>

<script>
import {
  Button,
  IconButton,
  SidebarSection,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import ModalDeleteAccount from 'client/settings/AdministratorSettings/Modals/ModalDeleteAccount.vue';
import ModalEmail from 'client/settings/AdministratorSettings/Modals/ModalEmail.vue';
import OauthProviderManagement from 'client/components/Modal/Admin/OauthProviderManagement.vue';

const administratorModel = 'AdministratorModel';

export default {
  name: 'AdministratorAccountSection',

  components: {
    Button,
    IconButton,
    ModalDeleteAccount,
    ModalEmail,
    OauthProviderManagement,
    SidebarSection,
  },

  props: {
    administratorId: {
      type: String,
      required: true,
    },
    buttonDisabled: Boolean,
  },

  data() {
    return {
      loadingAccount: false,
      loadingDeleteAccount: false,
      loadingEmail: false,
      showModalEmail: false,
      showModalDeleteAccount: false,
      returnToRoute: '/settings/administrators',
    };
  },

  computed: {
    ...mapState(administratorModel, [
      'item',
    ]),

    buttonConfigDeleteAccount() {
      return {
        icon: 'delete',
        type: 'error',
        text: 'Delete Account',
      };
    },
    buttonConfigEmail() {
      return {
        disabled: this.buttonDisabled,
        type: 'primary',
        text: 'Send Password Reset Email',
      };
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions(administratorModel, [
      'deleteItem',
      'fetchItem',
      'resendEmail',
      'saveItem',
    ]),

    ...mapActions(notificationModule, [
      'triggerSuccessNotification',
      'triggerErrorNotification',
    ]),

    handleConfirmCloseDeleteAccount() {
      this.showModalDeleteAccount = false;
    },

    handleConfirmCloseEmail() {
      this.showModalEmail = false;
    },

    async handleConfirmContinueDeleteAccount() {
      const { email, _id } = this.item;
      this.loadingDeleteAccount = true;

      try {
        await this.deleteItem(_id);
        this.triggerSuccessNotification({
          message: `Account for ${email} deleted.`,
          title: 'Account deleted',
        });
      } catch (err) {
        this.triggerErrorNotification({
          message: `Unable to delete account for ${email}.`,
          title: 'Error',
        });
      } finally {
        this.loadingDeleteAccount = false;
        this.$router.push(this.returnToRoute);
      }
    },

    async handleConfirmContinueEmail() {
      const { email } = this.item;
      this.loadingEmail = true;
      try {
        await this.resendEmail(this.item._id);
        this.triggerSuccessNotification({
          message: `Password reset email sent to ${email}.`,
          title: 'Email sent',
        });
      } catch {
        this.triggerErrorNotification({
          message: `Error sending email to ${this.item.email}.`,
          title: 'Error',
        });
      }
      this.loadingEmail = false;
    },

    handleDeleteAccount() {
      this.showModalEmail = false;
      this.showModalDeleteAccount = true;
    },

    handleMounted() {
      this.fetchItem(this.administratorId);
    },

    handleResendEmail() {
      this.showModalDeleteAccount = false;
      this.showModalEmail = true;
    },
  },
};
</script>

<style scoped module>
.noBackgroundButton {
  margin: 0 auto;
}

.container {
  display: grid;
  grid-gap: var(--jc-spacer);
}
</style>
